import { array, string, object, number } from 'yup'

export const winsSchema = array()
  .of(
    object({
      label: string().required(),
      games: array().of(
        object({
          win: number().min(1),
          name: string().required().min(1),
          icon: string().required().min(1),
          playerNick: string().required().min(1),
          slug: string().required().min(1),
        }),
      ),
    }),
  )
  .min(1)
